// test1560
(1560 && 0);
